/* Nolae — Idol A-Z. Built by idol-a-z-theme/scripts/build.py from src/az-chrome.js,
   the prototype's public/az.js and src/az-stock.js; do not edit by hand. */
/* ————— The store header on this page —————
   What the prototype's glass.js did for it, against Focal's own header:

   · Auto-hide: scrolling down slides the header away, scrolling back up
     brings it back (html.nolae-chrome-up — the blog pages' class and the
     same 24px / 120px runs, idol-a-z.css). Back at the top it always shows.
   · The hold: while az.js flies to a letter it sets data-chrome-hold on
     <html>, and the header stays away whichever way the page travels, so the
     rail is at the top edge when the jump lands and the landing is the same
     from above or below. The run starts fresh afterwards.
   · --chrome-top: where things pinned under the header park — its bottom
     edge while it shows, 0 while it is away. The rail's `top` (and on a
     phone its height) is that value; the sections' scroll-margin too. */
(function () {
  "use strict";
  var root = document.documentElement;
  var headerEl = document.querySelector('.shopify-section--header, [id^="shopify-section"][id$="__header"]');
  if (!headerEl) return;

  var up = false;
  var lastY = window.scrollY;
  var run = 0;
  var DELTA = 2, HIDE_AFTER = 24, REVEAL_AFTER = 120;

  function sticky() {
    var p = getComputedStyle(headerEl).position;
    return p === "sticky" || p === "fixed";
  }
  var lastTop = -1;
  function publish() {
    var top = 0;
    if (!up && sticky()) top = Math.max(0, headerEl.getBoundingClientRect().top) + headerEl.offsetHeight;
    top = Math.round(top);
    if (top !== lastTop) { root.style.setProperty("--chrome-top", top + "px"); lastTop = top; }
  }
  function setUp(v) {
    if (v && document.body.classList.contains("lock-all")) v = false; // a drawer is open
    if (v === up) return;
    up = v;
    root.classList.toggle("nolae-chrome-up", v);
    publish();
    // The header is sliding; listeners that measure it hear about it.
    [80, 200, 340].forEach(function (ms) { setTimeout(function () { window.dispatchEvent(new Event("scroll")); }, ms); });
  }
  function autoHide() {
    var y = window.scrollY;
    if (root.hasAttribute("data-chrome-hold")) { lastY = y; run = 0; setUp(true); return; }
    var diff = y - lastY;
    if (Math.abs(diff) < DELTA) return;
    lastY = y;
    if (diff > 0 !== run > 0) run = 0;
    run += diff;
    if (y <= headerEl.offsetHeight) { run = 0; setUp(false); return; }
    if (run >= HIDE_AFTER) setUp(true);
    else if (run <= -REVEAL_AFTER) setUp(false);
  }

  /* ————— The glass under header and rail (desktop) —————
     Once the letter rail is pinned, one frosted band runs from the top of
     the window down to the rail's lower edge — the header's recipe, 20%
     white under a 20px blur — so header and rail read as one piece of glass
     (the prototype's glass.js; the blog's breadcrumb trail does the same).
     The rail drops its own tint while pinned (.is-pinned), and Focal's own
     header glass steps aside (body.nolae-glass-on, idol-a-z.css), or two
     blurs would meet at a seam. The band sits under the rail (z 3) and the
     header (z 4). On a phone the rail is the side index, not a bar under
     the header, so there is no band. */
  var rail = document.querySelector(".nolae-az .az-rail");
  var MOBILE = window.matchMedia("(max-width: 768px)");
  var band = document.createElement("div");
  band.className = "nolae-glass";
  band.setAttribute("aria-hidden", "true");
  band.style.cssText = "position:fixed;left:0;right:0;top:0;height:0;background:rgba(255,255,255,0.2);-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px);z-index:2;pointer-events:none;";
  document.body.appendChild(band);
  var lastBand = -1;
  function glass() {
    if (!rail) return;
    var pinned = false, h = 0;
    if (!MOBILE.matches && window.scrollY > 0) {
      var r = rail.getBoundingClientRect();
      var stick = parseFloat(getComputedStyle(rail).top) || 0;
      pinned = r.top <= stick + 2;
      if (pinned) h = Math.max(0, Math.round(r.bottom));
    }
    rail.classList.toggle("is-pinned", pinned);
    document.body.classList.toggle("nolae-glass-on", pinned);
    if (h !== lastBand) { band.style.height = h + "px"; lastBand = h; }
  }

  function onScroll() { autoHide(); publish(); glass(); }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () { publish(); glass(); });
  MOBILE.addEventListener("change", glass);
  // Focal's header changes height as it settles after a scroll, with no
  // scroll event of its own; the rail's `top` eases after it for 0.32s.
  if (window.ResizeObserver) new ResizeObserver(function () { publish(); glass(); }).observe(headerEl);
  if (rail) rail.addEventListener("transitionend", glass);
  publish();
  glass();
})();

/* Idol A-Z — the page's behaviour.
 *
 * Vanilla and standalone so it ports to the theme unchanged, as
 * {{ 'az.js' | asset_url | script_tag }} — no imports, no build step.
 * Everything here is a layer over server-rendered HTML that already works:
 * the rail's links are real anchors and the entries are real links. This
 * file adds:
 *
 *   · the rail: current-letter tracking, smooth jumps that keep the letter
 *     heading clear of the header/rail (tip 3)
 *   · on a phone, the rail as a fixed full-height phonebook index — hidden
 *     until scrolled past the hero, header-aware height, touch-drag scrub
 *     with a floating letter bubble
 *   · letter keys as jumps when focus is outside a field (tip 11)
 *   · "Part of → group" jumps
 *   · the "Hide sold out" switch
 *
 * No search on this page (2026-09-23) — the A–Z rail is the one way in.
 */
(function () {
  "use strict";

  var root = document.documentElement;
  var rail = document.querySelector("[data-az-rail]");
  var directory = document.querySelector("[data-az-directory]");
  var header = document.querySelector('.shopify-section--header, [id^="shopify-section"][id$="__header"]');
  if (!rail || !directory) return;

  // The same 768px line as everywhere else (globals.css's breakpoint
  // convention) — below it the rail is a fixed phonebook-style index down
  // the right edge (page.css) instead of the bar pinned under the header.
  var MOBILE = window.matchMedia("(max-width: 768px)");

  var groups = [].slice.call(directory.querySelectorAll("[data-az-group]"));
  var keys = {};
  var keyEls = [];
  [].forEach.call(rail.querySelectorAll(".az-key"), function (k) {
    keys[k.getAttribute("data-letter")] = k;
    keyEls.push(k);
  });

  /* ————— The rail —————
     Its height is published for the sections' scroll-margin, and its
     current key follows the letter heading nearest the top of the viewport.

     On a phone the rail is a phonebook-style index down the right edge
     (page.css; sticky, fixed while stuck — see pinRail below) — not the
     bar pinned under the header. It no longer sits between the header
     and the content there, so it costs no scroll offset: --rail-h goes to
     0 and the header's own height carries the rest of the maths below. */
  function railHeight() { return MOBILE.matches ? 0 : rail.getBoundingClientRect().height; }
  function publishRail() { root.style.setProperty("--rail-h", railHeight().toFixed(1) + "px"); }
  publishRail();
  window.addEventListener("resize", publishRail);
  MOBILE.addEventListener("change", function () { publishRail(); track(); });

  /* ————— Sticky → fixed while stuck (phone only) —————
     The rail is position:sticky beside Directory: it scrolls past like
     ordinary content while idle, and sticks once it would leave the top.
     But on a real iPhone Safari draws that sticky rail off-screen for every
     frame it lags the scroll (a blank frame per jump or scrub step, the
     whole of a finger fling), so whenever it IS in its stuck state it is
     switched to position:fixed at the identical spot — iOS's scrolling
     thread holds fixed layers in place. See .az-rail.is-fixed in page.css.

     "Stuck" is worked out from the rail's container, never the rail itself
     (whose own rect is meaningless once fixed): its natural top would be
     at or above the stick line, and the container still reaches past the
     rail's full height below it. `delta` asks the same question for where
     the page is ABOUT to be, so a jump or scrub step can switch before the
     scroll lands rather than a frame after it. */
  var railBody = rail.closest(".az-body");
  var railFixed = false;
  function pinRail(delta) {
    var on = false;
    if (MOBILE.matches && railBody) {
      var b = railBody.getBoundingClientRect();
      var cs = getComputedStyle(rail);
      var stick = parseFloat(cs.top) || 0;
      var idle = parseFloat(cs.getPropertyValue("--rail-idle")) || 0;
      var top = b.top - (delta || 0), bottom = b.bottom - (delta || 0);
      on = top + idle <= stick && bottom >= stick + rail.offsetHeight;
    }
    if (on === railFixed) return;
    railFixed = on;
    rail.classList.toggle("is-fixed", on);
    if (railBody) railBody.classList.toggle("has-fixed-rail", on);
  }
  window.addEventListener("scroll", function () { pinRail(0); }, { passive: true });
  window.addEventListener("resize", function () { pinRail(0); });
  MOBILE.addEventListener("change", function () { pinRail(0); });
  pinRail(0);

  function chromeBottom() {
    if (MOBILE.matches) {
      // Nothing else is pinned under the header on this view — the rail
      // floats independently of it, so only the header's own edge (which
      // may itself be hidden, mid scroll) decides what counts as "arrived".
      return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    }
    var r = rail.getBoundingClientRect();
    // Pinned: the rail's own bottom is the chrome's edge. Not yet pinned
    // (top of the page): where it WILL pin — header height plus its own.
    var cs = getComputedStyle(rail);
    var stick = parseFloat(cs.top) || 0;
    return r.top <= stick + 1 ? r.bottom : stick + r.height;
  }

  var active = null;
  /* True for the length of a jumpTo() travel. The key that was pressed is
     already set current; without this, every scroll event on the way would
     re-run track() and walk the highlight through each letter the page
     passes (J… K… for a jump from A to K) instead of it landing once. */
  var jumping = false;
  var jumpSeq = 0;
  function setActive(letter) {
    if (letter === active) return;
    if (active && keys[active]) keys[active].removeAttribute("aria-current");
    active = letter;
    var k = keys[letter];
    if (!k) return;
    if (k.tagName === "A") k.setAttribute("aria-current", "true");
    var list = rail.querySelector(".az-rail-list");
    if (!list) return;
    if (MOBILE.matches) {
      // The phonebook rail only scrolls (vertically) on a viewport too
      // short to fit all 27 keys — most phones do not need this.
      if (list.scrollHeight > list.clientHeight) {
        var kr = k.getBoundingClientRect(), lr = list.getBoundingClientRect();
        if (kr.top < lr.top + 8 || kr.bottom > lr.bottom - 8) {
          list.scrollTo({ top: k.offsetTop - list.clientHeight / 2 + k.offsetHeight / 2, behavior: "smooth" });
        }
      }
    } else if (list.scrollWidth > list.clientWidth) {
      var kr2 = k.getBoundingClientRect(), lr2 = list.getBoundingClientRect();
      if (kr2.left < lr2.left + 18 || kr2.right > lr2.right - 18) {
        list.scrollTo({ left: k.offsetLeft - list.clientWidth / 2 + k.offsetWidth / 2, behavior: "smooth" });
      }
    }
  }
  function track() {
    if (jumping) return;
    // 40px of tolerance: a section whose heading is within a heading's
    // height of the rail is the one the reader is looking at — and a jump
    // lands the heading a few pixels under the rail, which must count.
    var edge = chromeBottom() + 40;
    var best = null;
    for (var i = 0; i < groups.length; i++) {
      /* A section that isn't rendered — an empty letter's [hidden] one, or
         one the "Hide sold out" switch emptied — has a 0 top, which reads
         as "above the edge" and would steal current from the section the
         reader is actually in. */
      if (!groups[i].getClientRects().length) continue;
      var top = groups[i].getBoundingClientRect().top;
      if (top <= edge) best = groups[i]; else break;
    }
    if (!best) {
      // Above the first section: nothing is current.
      if (active) { keys[active] && keys[active].removeAttribute("aria-current"); active = null; }
      return;
    }
    setActive(best.getAttribute("data-az-group"));
  }
  window.addEventListener("scroll", track, { passive: true });
  window.addEventListener("resize", track);
  track();

  /* Same restart trick as .is-target below: remove, force a reflow so the
     browser forgets the animation ran, then add — needed for re-tapping a
     letter that's already popped once (a bare class add is a no-op the
     second time, CSS animations don't replay on their own). */
  function popLetter(section) {
    var l = section && section.querySelector(".az-letter-l");
    if (!l) return;
    l.classList.remove("is-popping");
    void l.offsetWidth;
    l.classList.add("is-popping");
  }

  /* ————— Jumps —————
     A jump lands the target under the rail. The header is asked to stay
     away for the length of the travel (data-chrome-hold, which glass.js
     honours), so the rail is pinned at the top edge when we arrive and the
     landing position is the same whichever way the page travelled.

     `onDone`, if given, runs once the travel is over — not before: the
     scroll itself takes ~0.9s (Lenis) or ~0.7s (plain), both longer than
     the letter-pop's own 0.6s, so firing the pop on click the way the
     scroll's own start does would let it finish while the target was
     still travelling into view, off in the wrong place for the reader to
     ever see it play. `done` guards it to once — the natural onComplete
     and the timeout fallback below can both still fire, and either one
     only really releases once the page has arrived (see arrived()). */
  function jumpTo(el, extra, onDone) {
    if (!el) return;
    root.setAttribute("data-chrome-hold", "");
    window.dispatchEvent(new Event("scroll"));
    var y = window.scrollY + el.getBoundingClientRect().top - railHeight() - (extra || 10);
    y = Math.max(0, y);
    var done = false, waiting = false;
    // A second tap mid-travel starts a new jump; only the newest one may
    // lift the lock, or the first one's fallback timer would lift it early.
    var seq = ++jumpSeq;
    jumping = true;
    /* Arrival is checked, not assumed. On a fresh page load the travel
       can outlast the fallback timer below, and a release on the timer
       alone let track() measure mid-flight and flash the letter before
       the target (K → J → K). So release() keeps re-checking each frame
       until the page is actually there — or it's been long enough that
       something else (a reader's own scroll) has clearly taken over. */
    var giveUp = Date.now() + 3000;
    function arrived() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      return Math.abs(window.scrollY - Math.min(y, max)) < 2;
    }
    function release() {
      if (done || waiting) return;
      if (seq !== jumpSeq) { done = true; return; }
      if (!arrived() && Date.now() < giveUp) {
        waiting = true;
        requestAnimationFrame(function () { waiting = false; release(); });
        return;
      }
      done = true;
      root.removeAttribute("data-chrome-hold");
      // glass.js only re-evaluates the header on a scroll event; without
      // this nudge a jump that ends at the top would leave the bar hidden.
      // (track() still stands down for it — `jumping` is not lifted yet.)
      window.dispatchEvent(new Event("scroll"));
      // Land on the target's own letter rather than measuring for it, and
      // only resume measuring a couple of frames on, once it has settled.
      var g = el.closest("[data-az-group]");
      if (g) setActive(g.getAttribute("data-az-group"));
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (seq !== jumpSeq) return;
          jumping = false;
          track();
        });
      });
      if (onDone) onDone();
    }
    /* Eased travel on every screen size. (On phones it briefly landed in one
       step instead, because iOS Safari dropped the sticky rail for frames at
       a time while script moved the page; the rail is now position:fixed
       whenever it's stuck — pinRail — which iOS holds in place through any
       scroll, so the animation is safe again. pinRail re-checks on every
       scroll event of the travel, so a jump that starts with the rail idle
       at the top still lets it ride up and stick as it would by hand.) */
    if (window.__lenis && window.__lenis.scrollTo) {
      window.__lenis.scrollTo(y, { duration: 0.9, onComplete: release });
      setTimeout(release, 1200);
    } else {
      window.scrollTo({ top: y, behavior: "smooth" });
      setTimeout(release, 700);
    }
  }

  rail.addEventListener("click", function (e) {
    var a = e.target.closest("a.az-key");
    if (!a) return;
    e.preventDefault();
    if (a.classList.contains("is-off")) return; // its section is filtered out
    var id = a.getAttribute("href").slice(1);
    var target = document.getElementById(id);
    if (!target) return;
    history.replaceState(history.state, "", "#" + id);
    jumpTo(target, 10, function () { popLetter(target); });
    // The key the reader pressed is current from now, whatever track()
    // reads mid-travel.
    setActive(a.getAttribute("data-letter"));
  });

  /* ————— Phonebook drag (mobile only) —————
     The rail's fixed right-edge index (page.css) has small targets by
     design — a real phonebook index does too — and this is what keeps it
     usable anyway: touching down anywhere on the rail and sliding the
     thumb up or down scrubs through the letters, landing wherever it
     stops, with a floating bubble showing which one. A plain tap (no real
     movement) never calls preventDefault, so it falls straight through to
     the click handler above and gets that nicer animated jump — scrubbing
     jumps instantly instead, because an eased scroll cannot keep up with a
     moving thumb. */
  var scrub = { on: false, dragging: false, x: 0, y: 0, letter: null };
  var DRAG_PX = 6; // real movement, not a twitch, before this counts as a drag
  var bubble = null;
  function scrubBubble() {
    if (bubble) return bubble;
    bubble = document.createElement("span");
    bubble.className = "az-scrub-bubble";
    bubble.setAttribute("aria-hidden", "true");
    (document.querySelector(".nolae-az") || document.body).appendChild(bubble);
    return bubble;
  }
  function letterAt(y) {
    var best = null, bestDist = Infinity;
    for (var i = 0; i < keyEls.length; i++) {
      var r = keyEls[i].getBoundingClientRect();
      var d = Math.abs(r.top + r.height / 2 - y);
      if (d < bestDist) { bestDist = d; best = keyEls[i]; }
    }
    return best;
  }
  function scrubTo(y) {
    var el = letterAt(y);
    if (!el) return;
    var letter = el.getAttribute("data-letter");
    if (letter !== scrub.letter) {
      scrub.letter = letter;
      // The same tick a real index gives per row crossed — harmless no-op
      // where the API does not exist (iOS Safari).
      if (navigator.vibrate) navigator.vibrate(3);
    }
    var b = scrubBubble();
    b.textContent = letter;
    var off = el.tagName !== "A" || el.classList.contains("is-off");
    b.classList.toggle("is-empty", off);
    b.classList.add("is-visible");
    if (off) return; // a grey key (empty, or filtered out): nothing to jump to
    var id = el.getAttribute("href").slice(1);
    var target = document.getElementById(id);
    if (!target) return;
    var top = window.scrollY + target.getBoundingClientRect().top - railHeight() - 10;
    pinRail(Math.max(0, top) - window.scrollY); // fixed before the page moves, not a frame after
    window.scrollTo(0, Math.max(0, top));
    history.replaceState(history.state, "", "#" + id);
    setActive(letter);
  }
  rail.addEventListener("touchstart", function (e) {
    if (!MOBILE.matches) return;
    scrub.on = true; scrub.dragging = false; scrub.letter = null;
    scrub.x = e.touches[0].clientX; scrub.y = e.touches[0].clientY;
  }, { passive: true });
  rail.addEventListener("touchmove", function (e) {
    if (!scrub.on) return;
    var t = e.touches[0];
    if (!scrub.dragging) {
      if (Math.abs(t.clientY - scrub.y) < DRAG_PX && Math.abs(t.clientX - scrub.x) < DRAG_PX) return;
      scrub.dragging = true;
      root.setAttribute("data-chrome-hold", "");
    }
    e.preventDefault(); // own the gesture once it is a real drag — no fighting the page scroll
    scrubTo(t.clientY);
  }, { passive: false });
  function scrubEnd() {
    if (!scrub.on) return;
    var wasDragging = scrub.dragging;
    scrub.on = false; scrub.dragging = false; scrub.letter = null;
    if (bubble) bubble.classList.remove("is-visible");
    if (wasDragging) {
      root.removeAttribute("data-chrome-hold");
      window.dispatchEvent(new Event("scroll"));
      track();
    }
    // else: a plain tap — untouched by preventDefault, so the browser's own
    // click still fires and the handler above already ran it.
  }
  rail.addEventListener("touchend", scrubEnd);
  rail.addEventListener("touchcancel", scrubEnd);

  /* "Part of → group": jumps to the group's own entry. */
  directory.addEventListener("click", function (e) {
    var a = e.target.closest("[data-az-jump]");
    if (!a) return;
    e.preventDefault();
    var target = document.getElementById(a.getAttribute("href").slice(1));
    if (!target) return;
    history.replaceState(history.state, "", a.getAttribute("href"));
    target.classList.remove("is-target");
    void target.offsetWidth; // restart the flash
    target.classList.add("is-target");
    jumpTo(target, 16);
  });


  /* Letter keys as jumps, when nothing that takes typing has focus (there
     is no search field on this page, but the guard still matters — the
     storefront header above it has its own search input). */
  document.addEventListener("keydown", function (e) {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    var t = e.target;
    var typing = t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable);
    if (typing) return;
    if (!/^[a-zA-Z#]$/.test(e.key)) return;
    var letter = e.key === "#" ? "#" : e.key.toUpperCase();
    var k = keys[letter];
    if (!k || k.tagName !== "A" || k.classList.contains("is-off")) return;
    e.preventDefault();
    k.click();
  });

  /* ————— "Hide sold out" —————
     The switch at the top of Directory. Hiding is one class on <html>
     (page.css hides every [data-az-soldout] row under it); what needs
     script is the fallout: a letter whose every card was sold out is now
     an empty section, so it is folded away, its count zeroed and its rail
     key greyed and made inert (is-off — the click, keyboard and scrub
     handlers above all check it) until the switch goes off again. The
     choice persists per browser (localStorage) as a plain convenience;
     nothing depends on it being there. */
  var hideSoldOut = document.querySelector("[data-az-hide-soldout]");
  if (hideSoldOut) {
    var HIDE_KEY = "az-hide-soldout";
    var applyHide = function (on) {
      root.classList.toggle("az-hide-soldout", on);
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        var all = g.querySelectorAll("[data-az-item]").length;
        var shown = on ? g.querySelectorAll("[data-az-item]:not([data-az-soldout])").length : all;
        g.classList.toggle("is-filtered-out", on && all > 0 && shown === 0);
        var n = g.querySelector(".az-letter-n");
        if (n) n.textContent = String(shown);
        var k = keys[g.getAttribute("data-az-group")];
        if (k && k.tagName === "A") k.classList.toggle("is-off", on && shown === 0);
      }
      if (window.__lenis && window.__lenis.resize) window.__lenis.resize();
      pinRail(0); // the list's length changed, so where the rail stops sticking did too
      track();
    };
    hideSoldOut.addEventListener("change", function () {
      applyHide(hideSoldOut.checked);
      try { localStorage.setItem(HIDE_KEY, hideSoldOut.checked ? "1" : "0"); } catch (e) { /* private mode etc. */ }
    });
    var remembered = null;
    try { remembered = localStorage.getItem(HIDE_KEY); } catch (e) { /* ditto */ }
    if (remembered === "1") { hideSoldOut.checked = true; applyHide(true); }
    window.__azStockChanged = function () { applyHide(hideSoldOut.checked); };
  }

  /* Arriving with a #hash — a shared or bookmarked link to one letter. */
  if (location.hash) {
    var h = document.getElementById(location.hash.slice(1));
    // Let the browser's own jump settle, then land it under the rail.
    if (h) setTimeout(function () { jumpTo(h, 10, function () { popLetter(h); }); }, 50);
  }
})();

/* ————— Thumbnails and sold-out ribbons, section by section —————
   The section renders every card with the name's initial where the picture
   goes and no ribbon: reading products for 650 collections in Liquid runs
   past Shopify's render limit. This fills both in from the Storefront API
   (tokenless — the storefront's own public endpoint, no key):

     top    the collection's best-selling product (sortKey BEST_SELLING, the
            same ranking as the storefront's "Best selling" sort) → its image
     avail  any product that can be bought (filters: available) — none, on a
            collection that has products, is "Ausverkauft"

   Progressively (2026-10-13): a letter section asks for its cards only once
   it comes within about a screen of the viewport, so the first view costs
   one or two small queries instead of all 629 cards' worth landing at once
   — that burst (13 answers, ~50 images and a sold-out recount each, inside
   ~300ms) is what made the first scroll stutter on a phone. The answers are
   written in one animation frame each, and each picture fades in once it
   has loaded, over the initial it replaces.

   "Hide sold out" needs every card's answer: turning it on (or arriving
   with it remembered on) asks for all the sections still missing, and the
   switch re-applies itself — once a frame at most — as they land.

   A card whose answer never comes keeps its initial and no ribbon — the page
   still works, it only looks plainer. */
(function () {
  "use strict";
  var root = document.querySelector(".nolae-az");
  if (!root || !window.fetch) return;
  var API = "/api/2026-07/graphql.json";
  var BATCH = 50; // 6 cost points each (tokenless queries allow 1000); 50 answers in ~1s
  var AHEAD = "900px 0px"; // start a section about a screen before it is reached
  var SOLD_OUT = root.getAttribute("data-sold-out") || "Ausverkauft";
  var sections = [].slice.call(root.querySelectorAll("[data-az-group]"));
  var sw = root.querySelector("[data-az-hide-soldout]");

  function query(batch) {
    var parts = batch.map(function (li, i) {
      return "c" + i + ': collection(handle: ' + JSON.stringify(li.getAttribute("data-handle")) + ') {' +
        ' top: products(first: 1, sortKey: BEST_SELLING) { nodes { featuredImage { url(transform: { maxWidth: 112, maxHeight: 112, crop: CENTER }) } } }' +
        ' avail: products(first: 1, filters: { available: true }) { nodes { id } } }';
    });
    return "{ " + parts.join(" ") + " }";
  }

  function fill(li, c) {
    if (!c) return;
    var top = c.top && c.top.nodes[0];
    var src = top && top.featuredImage && top.featuredImage.url;
    var thumb = src && li.querySelector(".az-thumb");
    if (thumb) {
      // Laid over the initial (idol-a-z.css), which stays until the picture
      // has loaded; then the picture fades in and the initial goes.
      var img = document.createElement("img");
      img.alt = ""; img.width = 56; img.height = 56;
      img.loading = "lazy"; img.decoding = "async";
      img.onload = function () {
        img.classList.add("is-in");
        thumb.classList.remove("az-thumb--blank");
        for (var n = thumb.firstChild; n; n = n.nextSibling) if (n.nodeType === 3) n.nodeValue = "";
      };
      img.src = src;
      thumb.appendChild(img);
    }
    var count = parseInt(li.getAttribute("data-count"), 10) || 0;
    if (count > 0 && c.avail && c.avail.nodes.length === 0) {
      li.setAttribute("data-az-soldout", "");
      var badge = document.createElement("span");
      badge.className = "az-badge az-badge--out";
      badge.textContent = SOLD_OUT;
      li.insertBefore(badge, li.firstChild);
    }
  }

  /* The switch only has work to do while it is on; while it is off a new
     ribbon changes nothing it shows. At most once a frame. */
  var queued = false;
  function stockChanged() {
    if (!sw || !sw.checked || queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      if (window.__azStockChanged) window.__azStockChanged();
    });
  }

  function request(batch) {
    return fetch(API, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ query: query(batch) })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var data = json && json.data;
        if (!data) return;
        requestAnimationFrame(function () {
          batch.forEach(function (li, i) { fill(li, data["c" + i]); });
          stockChanged();
        });
      })
      .catch(function () { /* keep the initials */ });
  }

  /* Every section newly asked for in one go shares the batches, so a
     reader landing between two small letters costs one query, not two. */
  function load(list) {
    var items = [];
    list.forEach(function (sec) {
      if (sec.__azLoaded) return;
      sec.__azLoaded = true;
      items = items.concat([].slice.call(sec.querySelectorAll("[data-az-item][data-handle]")));
    });
    var jobs = [];
    for (var i = 0; i < items.length; i += BATCH) jobs.push(request(items.slice(i, i + BATCH)));
    return Promise.all(jobs);
  }
  function loadAll() { return load(sections); }

  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function (entries) {
      var near = [];
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        near.push(e.target);
        io.unobserve(e.target);
      });
      if (near.length) load(near);
    }, { rootMargin: AHEAD });
    sections.forEach(function (sec) { io.observe(sec); });
  } else {
    loadAll();
  }

  // "Hide sold out" on — now, or remembered from a visit before.
  if (sw) {
    sw.addEventListener("change", function () { if (sw.checked) loadAll(); });
    if (sw.checked) loadAll();
  }
})();
